import React from 'react';
import {useTranslation} from 'react-i18next';
import {WarningCircle} from '../icons';
import {formatCompactMoney, formatFullMoney} from '../client/panel_v11/panelFormatters';

const RAW = {interpolation: {escapeValue: false}};

/**
 * «Quedan afuera hoy · 2 (invirtieron CLP 1.245.701 este período)», debajo de «Entran hoy · N» en la
 * vista previa de las campañas de una cuenta: el asistente de línea nueva (modal y tarjeta) y la edición
 * clásica de las cuentas de la línea. `leftOut` es lo que devuelve `campaignsLeftOutToday`.
 *
 * - Sin `leftOut` (backend viejo, cuenta sin campañas) o sin nada afuera, no dibuja nada.
 * - Con plata afuera, el aviso `out_warning` dice qué implica: no suma al presupuesto ni dispara alertas.
 *   La tarjeta (`compact`) no lo lleva —no entra—: lo dice el modal que abre al tocarla.
 */
export function LeftOutTodayPreview({leftOut, compact = false, className = ''}) {
    const {t} = useTranslation();
    if (!leftOut || !(leftOut.count > 0)) return null;

    const hasSpend = leftOut.spend > 0;
    const amount = compact
        ? formatCompactMoney(leftOut.currency, leftOut.spend)
        : formatFullMoney(leftOut.currency, leftOut.spend);
    const line = `${t('line_wizard.preview.out_today', {count: leftOut.count})}${hasSpend
        ? ` (${t('line_wizard.preview.out_spend', {count: leftOut.count, amount, ...RAW})})`
        : ''}`;

    // `span` y no `div`: en la tarjeta del asistente va adentro de un `<button>`, que sólo admite contenido
    // en línea. El SCSS lo hace bloque.
    return (
        <span className={`usp-left-out${hasSpend ? ' -with-spend' : ''}${compact ? ' -compact' : ''}${className ? ` ${className}` : ''}`}
              data-testid="left-out-today">
            <span className="usp-left-out__line">{line}</span>
            {hasSpend && !compact && (
                <span className="usp-left-out__warning">
                    <WarningCircle size={15} weight="bold" aria-hidden="true"/>
                    {t('line_wizard.preview.out_warning')}
                </span>
            )}
        </span>
    );
}

export default LeftOutTodayPreview;
